import React, { CSSProperties, FC } from "react";
import "./Image.scss";

interface PT {
  className: string;
  onClick?: () => void;
  style?: CSSProperties; // 👈 THÊM DÒNG NÀY
}

const Image: FC<PT> = ({ className, onClick, style }) => {
  return <div className={`custom-image ${className}`} onClick={onClick} style={style}></div>;
};

export default React.memo(Image);
